import ngRedux from 'ng-redux'
import { PROMO_CODE_ADDED } from '../sale-model.constant'
import { $rootScope } from '../../../ng-compat/imports'
import { SaleManager } from '../../../managers/sale-manager'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'
import { hasLineItems, isConfirmed, isReturn } from '../../../functions/sale'
import template from './sale-promo-code-popover.html'

/**
 * Controller for the sale-promo-code component.
 *
 * @class SaleDiscountController
 */
export class SalePromoCodeController {
  constructor(
    private $element: JQLite,
    private vdPopover: $TSFixMe,
    public saleManager: SaleManager,
    private readonly $ngRedux: ngRedux.INgRedux
  ) {
    'ngInject'
  }

  /**
   * Determine whether giving promo code link should be disabled based on promotions and sale state.
   *
   * @method isDisabled
   * @return {Boolean} true if the promo code link should be disabled
   */
  public isDisabled(): boolean {
    const reduxSale = selectCurrentSale(this.$ngRedux.getState())

    return Boolean(
      !this.saleManager.hasActiveSale() ||
        !this.saleManager.getHasActivePromotions() ||
        !hasLineItems(reduxSale) ||
        isReturn(reduxSale) ||
        isConfirmed(reduxSale) ||
        reduxSale.isSavedUnfulfilled ||
        reduxSale.isSavedService
    )
  }

  /**
   * Show the promo code popover to the user so they can add/validate a sale promo code.
   *
   * @method showDiscountPopover
   */
  public showAddPromoCodePopover() {
    this.vdPopover
      .open({
        trigger: this.$element,
        template,
        controller: 'SalePromoCodePopoverController',
        direction: 'left',
      })
      .then((modal: $TSFixMe) => {
        modal.closed.then((promoCodeAdded: $TSFixMe) => {
          if (promoCodeAdded) {
            $rootScope.$emit(PROMO_CODE_ADDED)
          }
        })
      })
  }
}
